import { createAction, props } from '@ngrx/store';

export const processReverseInvoiceStart = createAction('[REVERSE INVOICE] Process Reverse Invoice Start');

export const processReverseInvoiceSuccess = createAction(
    '[HUB CONNECTION SERVICE] Process Reverse Invoice Success',
    props<{ created: [] }>()
);

export const processReverseInvoiceFailure = createAction(
    '[HUB CONNECTION SERVICE] Process Reverse Invoice Failure',
    props<{ error: string }>()
);

export const ensureConnectedToReverseInvoiceProcessingFeed = createAction('[REVERSE INVOICE] Ensure connected to hub');
export const disconnectFromReverseInvoiceProcessingFeed = createAction('[REVERSE INVOICE] Disconnect from hub');
